export default class ExternalEvents {
    constructor(events) {
        this.externalEventListeners = {};

        for (const event of events) {
            this.externalEventListeners[event] = [];
        }
    }

    on(event, handler) {
        if (this.externalEventListeners[event] && typeof handler === "function") {
            this.externalEventListeners[event].push(handler);
        }
    }

    runExternalEventHandlers(event, e) {
        if (this.externalEventListeners[event] && this.externalEventListeners[event].length !== 0)
            this.externalEventListeners[event].forEach((eventHandler) =>
                eventHandler.call(null, e.target, this, e)
            );
    }
}
